<template>
    <div class="img-ver">
        <div class="img-verify">
            <div class="img-title">{{mes1}}</div>
            <div class="code-img">
                <img :src="imgSrc">
                <div class="refresh" @click="getImgCode">{{refreshText}}</div>
            </div>
            <div class="request">{{request}}</div>
            <VerifyCode :num="4" type="password" @fillCb="fill" ref="vc"></VerifyCode>
        </div>
    </div>
</template>
<script>
import { fetchPost, fetchGet } from 'common-js/api/http.js'
import { setPageTitle } from '@didi/public-sdk'
import { toast } from '../api'
import { urlObj } from '../config'
import VerifyCode from '../components/VerifyCode'
import { mapGetters } from 'vuex'
import { oMegaData, name_auth_omega_summary } from 'common-js/omega'

// const query = resolveQuery(location.href)

export default {
  data () {
    return {
      mes1: '请输入图形内验证码',
      imgSrc: '',
      refreshText: '点击刷新',
      request: '4位字母(不区分大小写)',
      type: 1
    }
  },
  computed: {
    ...mapGetters({
    // eslint-disable-next-line indent
      verifyData: 'verifyData',
      ticket: 'ticket'
    })
  },
  mounted () {
    setPageTitle({ title: '' })
    this.$nextTick(() => {
      this.getImgCode()
      this.type = this.$route.query.type || this.type
    })
  },
  methods: {
    async getImgCode () {
      const res = await fetchGet({
        url: urlObj.getImgCode,
        params: {
          ticket: this.ticket,
          type: this.type,
          risk: {}
        }
      })
      const { errno, errmsg, data } = res
      if (errno * 1 === 0) {
        this.imgSrc = `data:image/png;base64,${data.img}`
      } else if (errno * 1 === 5003) {
        toast(this, { txt: '刷新过于频繁', time: 1000 })
      } else if (errno * 1 === 5004) {
        toast(this, { txt: '验证失败过多', time: 1000 })
      }
      oMegaData(name_auth_omega_summary['pub_trinity_verification_sw_bt'], {
        errno,
        errmsg,
        type: 'graphic'
      })
    },
    async checkCode (code) {
      const res = await fetchPost({
        url: urlObj.checkImgCode,
        data: {
          ticket: this.ticket,
          type: this.type,
          code: code
        }
      })
      const { errno, errmsg } = res
      if (errno * 1 === 0) {
        this.$router.replace({
          name: 'MesVerify',
          query: {
            type: this.type
          }
        })
      } else if (errno * 1 === 5002) {
        toast(this, { txt: '验证码错误', type: 'warn', time: 1000 })
        this.$refs.vc.clear()
      }
      oMegaData(name_auth_omega_summary['pub_trinity_verification_sw_bt'], {
        errno,
        errmsg,
        type: 'graphic'
      })
    },
    fill (code) {
      toast(this, { time: 5000 })
      this.checkCode(code)
    }
  },
  components: {
      VerifyCode
  }
}
</script>
<style lang="scss">
@import '~common-css/func.scss';
  .img-ver{
    position: absolute;
    width: 100%;
    height: 100%;
    background: #fff;
    .img-verify {
      font-family: "PingFangSC-Regular", "Microsoft YaHei", "Arial", "sans-serif";
      width: px2rem(558);
      height: 100%;
      text-align: left;
      padding-top: px2rem(132);
      margin: 0 auto;
      .img-title {
        font-family: "PingFangSC-Medium", "STHeitiSC-Medium", "HelveticaNeue-Medium";
        font-size: px2rem(48);
        color: #333;
      }
      .code-img {
        position: relative;
        width: px2rem(558);
        height: px2rem(240);
        text-align: center;
        background-color: #fff;
        padding-top: px2rem(20);
        margin-top: px2rem(20);
        img {
          width: px2rem(558);
          height: px2rem(180);
        }
        .refresh {
          position: absolute;
          right: px2rem(20);
          bottom: px2rem(20);
          font-size: px2rem(24);
          color: #4a4c5b;
        }
      }
        .request {
          font-size: px2rem(24);
          color: #ccc;
          margin: px2rem(79) 0 px2rem(8);
        }
    }
  }
  @media screen and (max-width: 320px) {
    .imgVerify {
      padding-top: px2rem(52);
    }
  }
</style>
